import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  height: 525px;
  background-color: #3b045e;
  color: #fff;
  padding-top: ${(props) => (props.isIe ? "119px" : "94px")};
  display: flex;
  justify-content: center;
  padding-bottom: 600px;

  ${mediaMaxWidth.smallDesktop`
    padding-top: 48px;
    padding-top: ${(props) => (props.isIe ? "73px" : "48px")};
  `}

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  .fadeIn {
    animation-name: fadeIn;
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translate3d(0, 100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  .fadeInUp {
    animation-name: fadeInUp;
  }

  @keyframes fadeInLeft {
    from {
      opacity: 0;
      transform: translate3d(-100%, 0, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  .fadeInLeft {
    animation-name: fadeInLeft;
  }

  .animated {
    animation-duration: 0.5s;
    animation-fill-mode: both;
  }

  .animated.delay-1 {
    animation-delay: 0.15s;
  }

  .animated.delay-2 {
    animation-delay: 0.3s;
  }

  .animated.delay-3 {
    animation-delay: 0.45s;
  }

  .animated.delay-4 {
    animation-delay: 0.6s;
  }

  .animated.delay-5 {
    animation-delay: 0.75s;
  }

  .animated.delay-6 {
    animation-delay: 0.9s;
  }
`;

export const FormWrapper = styled.div`
  width: 500px;
  height: 100%;
`;

export const Title = styled.h3`
  text-align: center;
  line-height: 3rem;
  font-size: 1.875rem;
  color: #fff;
  font-weight: 500;
  margin: 45px 0 10px 0;

  ${mediaMaxWidth.phone`
    font-size: 1.55em;
  `}

  ${mediaMaxWidth.smallPhone`
    font-size: 1.4em;
  `}
`;

export const Form = styled.form`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 60px 0 0 0;
  position: relative;
`;

export const Field = styled.div`
  position: relative;
`;

export const Input = styled.input`
  color: #000;
  background-color: #fff;
  border: 1px solid #a3bac6;
  width: 275px;
  border-radius: 3px;
  margin: 0.4rem 0 16px 0;
  padding: 0.5rem 0.625rem 0.5625rem;
  font-size: 0.9375rem;
  height: 2.6875rem;

  ::placeholder {
    color: #333;
    opacity: 0.5;
    font-weight: 300;
  }

  &:focus {
    border: 2px solid #79D9D9;
    outline: none;
  }
`;

export const Error = styled.div`
  padding-top: 0;
  padding-right: 0;
  color: #79D9D9;
  position: absolute;
  top: 50px;
  font-size: 0.8em;
  font-weight: 600;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const Button = styled.button`
  background: #402680;
  color: #79D9D9;
  font-size: 1.125rem;
  line-height: 3.25rem;
  font-family: Komet;
  font-weight: 900;
  border-radius: 9px;
  border: 1px solid #402680;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(1, 1, 1, 0.5);
  transition: ease-in-out 0.1s;
  width: 130px;
  text-align: center;
  margin: 30px 0;

  &:hover {
    background: #fff;
    border: 1px solid #b70d6c;
  }
`;
